import { IHistoricalOrder, IServerOrder } from '@rbi-ctg/menu';
import { IImageFragment } from 'generated/sanity-graphql';
import { MappedCartEntry, MappedOrder } from 'pages/menu/components/menu-reorder-widget/types';
import { useUIContext } from 'state/ui';
import { parseStringifiedJSON } from 'utils/parse-string';

type ItemHighlighted = {
  name: string;
  image: IImageFragment;
};

interface UseOrderDetailsReturn {
  totalPrice: string;
  itemHighlighted: ItemHighlighted | null;
  totalItems: number;
  itemNames: string;
}

function isMappedOrder(order: IServerOrder | IHistoricalOrder): order is MappedOrder {
  return 'orderEntries' in order;
}

export const useOrderDetailsCard = (
  order: IServerOrder | IHistoricalOrder,
  isReorder: boolean = false
): UseOrderDetailsReturn => {
  const { formatCurrencyForLocale } = useUIContext();

  const {
    cart: { cartEntries, totalCents },
  } = order;

  const entries = cartEntries ?? [];
  const orderDetailsEntries: MappedCartEntry[] =
    isReorder && isMappedOrder(order) ? order.orderEntries : [];
  const totalItems = entries.reduce((total, cartEntry) => total + (cartEntry.quantity ?? 1), 0);
  const totalPrice = formatCurrencyForLocale(totalCents);
  const itemNames =
    isReorder && isMappedOrder(order)
      ? orderDetailsEntries.map(item => item.name).join(' - ')
      : entries.map(item => item.name).join(' - ');
  const itemHighlighted = {
    name: entries[0]?.name || '',
    image: parseStringifiedJSON({
      value: entries[0]?.image || '',
    }),
  };

  return {
    totalItems,
    totalPrice,
    itemHighlighted,
    itemNames,
  };
};
